"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledButtonGroup = void 0;
var styled_components_1 = require("styled-components");
var theme_1 = require("../../utils/theme");
var getButtonGroupStyles = function (value) {
    /* tslint:disable */
    var spaces = {
        sm: theme_1.scaffolding.xs,
        lg: theme_1.scaffolding.sm
    };
    /* tslint:enable */
    if (typeof value === 'number') {
        return value + "px";
    }
    return spaces[value] ? spaces[value] : value;
};
exports.StyledButtonGroup = styled_components_1.default.div({
    display: 'flex',
    position: 'relative'
}, function (_a) {
    var alignItems = _a.alignItems, justifyContent = _a.justifyContent, flexDirection = _a.flexDirection, spacingSize = _a.spacingSize;
    return ({
        /* tslint:disable */
        '[class*="ap-button-"]:nth-child(n)': {
            margin: "0px " + getButtonGroupStyles(spacingSize)
        },
        '[class*="ap-button-"]:first-child': {
            marginLeft: '0px'
        },
        '[class*="ap-button-"]:last-child': {
            marginRight: '0px'
        },
        alignItems: alignItems,
        justifyContent: justifyContent,
        flexDirection: flexDirection
        /* tslint:enable */
    });
});
//# sourceMappingURL=styles.js.map